import { type FC, useEffect, useRef } from 'react';
import { SearchInput } from '@interstate/components/SearchInput';
import { Typography } from '@interstate/components/Typography';

export interface SearchFieldProps {
    testIdPrefix: string;
    label: string;
    placeholder: string;
    value: string;
    onChange: (value: string) => void;
    onSearch: () => void;
    onClear: () => void;
}

/** The labelled query input. Owns the autofocus, so the view keeps no DOM refs of its own. */
const SearchField: FC<SearchFieldProps> = ({ testIdPrefix, label, placeholder, value, onChange, onSearch, onClear }) => {
    const containerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (containerRef.current) {
            const input = containerRef.current.querySelector('input');
            input?.focus();
        }
    }, []);

    return (
        <>
            <Typography variant="label-md" sx={{ display: 'block', marginBottom: '0.25rem', color: '#6d6d6d' }}>
                {label}
            </Typography>
            <div ref={containerRef}>
                <SearchInput
                    id={`${testIdPrefix}-input`}
                    data-testid={`${testIdPrefix}-input`}
                    name={testIdPrefix}
                    placeholder={placeholder}
                    inputValue={value}
                    onInputChange={(e: any) => onChange(e.target.value ?? '')}
                    onSearchClick={onSearch}
                    onClearCallback={onClear}
                    style="primary"
                    size="small"
                    sx={{ marginBottom: '0.5rem' }}
                />
            </div>
        </>
    );
};

export default SearchField;
